<ng-template #verify_otp>
	<div class="modal-header text-center">
		<h5 class="modal-title">{{'SHARED.ELEMENT.EMAIL.VERIFICATION' | translate}}</h5>
		<span>{{'SHARED.ELEMENT.EMAIL.ENTER_THE_VERIFICATION_CODE' | translate}}<br/>{{'SHARED.ELEMENT.EMAIL.SEND_OTP_ON_YOUR_EMAIL' | translate}}</span>
		<button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()"><img src="{{env.SITE_IMAGE_URL}}close-icon.svg" alt="img"></button>
	</div>
	<div class="modal-body">
		<div class="myaccount_content">
			<div class="login-form">
				<div class="verificationcode">
					<form id="otpForm" [formGroup]="otpForm" (keydown)="otpFormSubmit($event)">
					<div class="login-form">
						<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<input type="text" class="form-control" formControlName="otp"  placeholder="{{'FORM_PLACEHOLDER.ENTER_OTP' | translate}}">
								<control-messages *ngIf="!otpFormError.otp"  [name]="'FORM.OTP' | translate" [control]="otpForm.controls.otp"></control-messages>
								<div *ngIf="otpFormError.otp!=''" class="error-block-form">{{ otpFormError.otp }}</div>
							</div>
						</div>
						</div>
					</div>
					</form>
				</div>
			<button type="button" class="btn btn-primary" [ladda]="otpSubmit" (click)="submitOtp()">{{'SHARED.ELEMENT.EMAIL.VERIFY' | translate}}</button>
			<div class="logininfo resendcode">
				<p><a href="javascript:void(0)" (click)="resendOtp()">{{'SHARED.ELEMENT.EMAIL.RESEND_CODE' | translate}}</a></p>
			</div>
			</div> 
		</div>
	</div>  
</ng-template>